export default "__VITE_ASSET__600a8648__"